// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"27d7428a","314":"a92bb21f","478":"0b10cb04","704":"560440bc","759":"5896cd9c","828":"eec5753b","845":"b7e7fac9"}[chunkId] + ".chunk.js";
};